import TaskList from "./components/List"
import TaskForm from "./components/Form"
import TaskView from "./components/View"

let module = "tasks"

export default [
  { path: "tasks", component: TaskList, meta: { module: module, permissions: ["task-access"] } },
  {
    path: "tasks/create",
    component: TaskForm,
    props: true,
    meta: { module: module, permissions: ["task-create"] }
  },
  {
    path: "tasks/edit/:id",
    component: TaskForm,
    props: true,
    meta: { module: module, permissions: ["task-edit"] }
  },
  {
    path: "tasks/view/:id",
    component: TaskView,
    props: true,
    meta: { module: module, permissions: ["task-access"] }
  }
]
